// g2-dag-rule-notes.ts
//
// Read-only DAG warnings appended to the G2 request reason AFTER the plan hash
// (they never move the request id or the snapshot): rule 5 (missing
// integration slice, V2 §4.3 E5) and rule 6 (phase 06j R3: a fresh DAG shape
// the RED-window rule would stall — dry run from all-todo, fix printed with
// `--mission`). Retired tickets are out of the plan (same rule as the snapshot).
import { RETIRED_TICKET_STATUSES } from "./g2-plan-readiness.js";
import type { Ticket } from "./schemas/ticket-schema.js";
import { findRedWindowConflictWarning } from "./ticket-dag-red-window-dry-run-warning.js";
import { findMissingIntegrationSliceWarning } from "./ticket-dag-validator.js";

export function g2DagRuleNotes(
  tickets: Ticket[],
  ticketStatus: Readonly<Record<string, string>>,
  missionId: string,
): string[] {
  const active = tickets.filter((t) => !RETIRED_TICKET_STATUSES.has(ticketStatus[t.id] ?? "todo"));
  const notes = [
    findMissingIntegrationSliceWarning(active),
    findRedWindowConflictWarning(active, missionId),
  ];
  return notes.filter((note): note is string => note !== undefined);
}
